/**
 * 企微 WebView 内排查用调试浮窗。
 * - 默认不挂载 DBG（生产对用户隐藏）；本地开发见仓库 `.env.development` 中 REACT_APP_SHOW_DEBUG_FLOAT=1。
 * - 仍支持 REACT_APP_HIDE_DEBUG_FLOAT=1 强制关闭（与旧交付包一致）。
 * - URL debug=1 / dbg=1 / his_debug=1：写入 sessionStorage（企微若禁用 storage 则仅内存，见 initDebugFloatFromUrl）
 * - URL debug=0：关闭并清 sessionStorage
 */

const STORAGE_KEY = "his_debug_float";

let debugFloatMemoryFlag = false;

function getAllQueryStrings(): string[] {
  const out: string[] = [];
  try {
    const s = globalThis.location.search;
    if (s.length > 1) out.push(s.slice(1));
    const hash = globalThis.location.hash || "";
    const qIdx = hash.indexOf("?");
    if (qIdx >= 0) out.push(hash.slice(qIdx + 1));
  } catch {
    /* ignore */
  }
  return out;
}

function parseDebugParamFromUrl(): "on" | "off" | "none" {
  try {
    for (const segment of getAllQueryStrings()) {
      const q = new URLSearchParams(segment);
      const v =
        q.get("debug") ?? q.get("dbg") ?? q.get("his_debug") ?? q.get("crm_debug");
      if (v === "1" || v === "true" || v === "yes") return "on";
      if (v === "0" || v === "false") return "off";
    }
  } catch {
    /* ignore */
  }
  return "none";
}

/** 在入口尽早调用 */
export function initDebugFloatFromUrl(): void {
  const mode = parseDebugParamFromUrl();
  if (mode === "on") {
    debugFloatMemoryFlag = true;
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch {
      /* 企微等环境可能禁用 storage */
    }
  } else if (mode === "off") {
    debugFloatMemoryFlag = false;
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch {
      /* ignore */
    }
  }
}

/** 是否允许挂载浮窗组件（为 false 时完全不渲染） */
export function shouldShowDebugFloat(): boolean {
  if (process.env.REACT_APP_HIDE_DEBUG_FLOAT === "1") return false;
  return process.env.REACT_APP_SHOW_DEBUG_FLOAT === "1";
}

/**
 * @deprecated 已与 CRM 对齐：只要 shouldShowDebugFloat() 为 true 即挂载，不再二次拦截。
 * 保留导出以免外部误用时报错。
 */
export function isDebugFloatEnabled(): boolean {
  return true;
}

/** 为 true 时首次进入展开面板（默认收起仅 DBG 按钮） */
export function isDebugPanelExpandedByDefault(): boolean {
  return process.env.REACT_APP_SHOW_DEBUG_EXPANDED === "1";
}
